export default class {
  // See app/assets/stylesheets/components/_turbo_modal.scss
  static cssClass = 'turbo-modal-scrollable-content';

  static defaultMaxHeightVh = 55;

  static maxHeightVhDatasetPropertyName = 'scrollableContentMaxHeightVh';

  constructor({ element }) {
    this.element = element;
  }

  onConnect() {
    this.element.classList.add(this.constructor.cssClass);
    this.element.style.maxHeight = `${this._maxHeightVh}vh`;
  }

  // private

  get _defaultMaxHeightVh() {
    return this.constructor.defaultMaxHeightVh;
  }

  get _maxHeightVhDatasetPropertyName() {
    return this.constructor.maxHeightVhDatasetPropertyName;
  }

  get _datasetMaxHeightVh() {
    return this.element.dataset[this._maxHeightVhDatasetPropertyName];
  }

  get _maxHeightVh() {
    return this._datasetMaxHeightVh || this._defaultMaxHeightVh;
  }
}
